module.exports = __webpack_public_path__ + "static/media/fin3.edb68edc.jpg";